import get from 'lodash/get';

const getIsExpanded = ({ visitedSubunits, key, unitNumber, expanderId }) => {
  /**
   * By default, auto expand only for unit 1
   * */
  const expandedDefaults = {
    1: unitNumber === '1',
  };
  const expandedSubunitDefaults = get(visitedSubunits, key, expandedDefaults);

  return expandedSubunitDefaults[expanderId] || false;
};

export default getIsExpanded;
